module.exports = "<div class=\"leaflet-control taelys-watermark\"> <div class=watermark> <img src=/images/logo_taelys.svg /> </div> <a ng-click=openCopyrightPopin() class=copyright-link> <i class=\"fa fa-copyright\"></i> <span>Mentions légales</span> </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/presentation/obsTaelysWatermark.html
// module id = 3579
// module chunks = 12